import CancelIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import classNames from 'classnames';
import trim from 'lodash/trim';
import { Field, Form } from 'react-final-form';

import Input from '@uptime/shared/components/Input';
import useContainerWidth from '@uptime/shared/hooks/useContainerWidth';

import SearchSwitcher from './SearchSwitcher';
import useStyles from './styles';

interface Props {
  initialValues: any;
  onOptionClick?: (...args: any) => void;
  onSubmit: (...args: any) => void;
  onReset: (...args: any) => void;
  onSwitch?: (...args: any) => void;
  margin?: number;
  isDisabledTrimming?: boolean;
  isOnChange?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
  className?: string;
  placeholder?: string;
  options?: any[];
  hideSearch?: boolean;
  isLowHeight?: boolean;
}

const Search = (props: Props) => {
  const classes = useStyles();
  const {
    disabled,
    children,
    onSubmit,
    onReset,
    initialValues,
    options,
    onOptionClick,
    isOnChange,
    className,
    placeholder,
    onSwitch,
    isDisabledTrimming,
    margin = 0,
    hideSearch = false,
    isLowHeight,
  } = props;
  const boxClasses = classNames({
    [classes.root]: true,
    // @ts-expect-error className mismatch
    [className]: true,
    [classes.hide]: hideSearch,
  });
  const [containerRef, containerWidth] = useContainerWidth();

  const dropDownStyles = {
    width: containerWidth,
  };

  const renderForm = ({ handleSubmit }: { handleSubmit: (...args: any) => React.ReactNode }) => {
    const eventHandler = isOnChange ? { onChangeCustom: handleSubmit } : {};

    return (
      <form className={classes.form} onSubmit={handleSubmit}>
        <Field
          disabled={disabled}
          autoComplete="off"
          autofill="off"
          name="search"
          placeholder={placeholder || 'Search…'}
          component={Input}
          options={options}
          onOptionClick={onOptionClick}
          dropDownStyles={dropDownStyles}
          className={isLowHeight ? classes.lowHeight : null}
          startAdornment={<SearchIcon className={classes.searchIcon} />}
          {...eventHandler}
          data-testid="search"
        />
      </form>
    );
  };

  const form = (
    <Form
      render={renderForm}
      onSubmit={(values) => {
        const trimmedSearch = {
          ...values,
          search: trim(values.search),
        };

        onSubmit(isDisabledTrimming ? values : trimmedSearch);
      }}
      initialValues={initialValues}
    />
  );

  return (
    <Box
      display="flex"
      alignItems="center"
      position="relative"
      zIndex="2"
      className={boxClasses}
      m={Number(margin)}
      // @ts-expect-error ref mismatch
      ref={containerRef}
    >
      {onSwitch && <SearchSwitcher onSwitch={onSwitch} />}
      {form}
      {initialValues.search && (
        <IconButton onClick={onReset} size="large">
          <CancelIcon />
        </IconButton>
      )}
      {children}
    </Box>
  );
};

export default Search;
